import React from 'react';

import Gauge from '@ant-design/charts/es/gauge';
import MeterGauge from '@ant-design/charts/es/meterGauge';

const chartComponents = {
  'gauge': Gauge,
  'metergauge': MeterGauge,
};

const Chart = ({ type, config, style }) => {
  const ChartComponent = chartComponents[type] || null;
  if (!ChartComponent) throw new Error(`Invalid chart type ${type}`);

  return <ChartComponent style={style} {...config} />;
};

export default Chart;